import { withHandlers, withState, compose, lifecycle } from 'recompose';

const withShopExpander = compose(
  withState('expandedShopId', 'setExpandedShopId', null),
  withHandlers({
    expandShop: (props) => (shopId) => {
      props.setExpandedShopId(shopId);
      props.ensureShopBarbersLoaded(shopId);
    },
  }),
  withHandlers({
    toggleExpandedShop: (props) => (shopId) => {
      const { expandedShopId, setExpandedShopId } = props;

      // If clicking the already expanded shop, collapse it
      if (expandedShopId === shopId) {
        setExpandedShopId(null);
        return;
      }

      // Otherwise expand the new shop
      props.expandShop(shopId);
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.shops.length > 0) {
        this.props.expandShop(this.props.shops[0].id);
      }
    },
  })
);

export default withShopExpander;
